import { SOURCE_MESSAGES } from '@his/shared';
import { tr, translateEnumValue } from '@/lib/i18n-core';
import { humanize } from '@/lib/utils';
import { ageSummary } from './registration-rules';

export function categoryLabel(category: string): string {
  const english = SOURCE_MESSAGES.enum[`patient_category.${category}`] ?? humanize(category);
  return translateEnumValue(category, english) ?? english;
}

export function ageSummaryText(summary: ReturnType<typeof ageSummary>): string | null {
  if (!summary) return null;
  if (summary.unit === 'days') return tr('opd', 'age_days_old', { count: summary.count });
  if (summary.unit === 'months') return tr('opd', 'age_months_old', { count: summary.count });
  return summary.estimated ? tr('opd', 'age_about_years', { count: summary.count }) : tr('opd', 'age_years_old', { count: summary.count });
}

export function sexText(sex: string | null | undefined): string | null {
  if (!sex) return null;
  return tr('opd', ['male', 'female', 'other'].includes(sex) ? sex : 'unknown');
}

export function describeRegistered(patient: { sex: string; dob: string | null; approximateAgeYears: number | null }): string {
  const age = ageSummaryText(ageSummary(patient.dob ? patient.dob.slice(0, 10) : null, patient.approximateAgeYears));
  return [sexText(patient.sex), age].filter(Boolean).join(' · ');
}
